import { SpaceBetween } from "@cloudscape-design/components-themed";

import { Main } from "../components/store-direct-application/Main";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/* 
店舗情報申請（直接）
 */
const StoreDirectApplication = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.APPLY);

  return (
    <SpaceBetween size="l">
      <Main />
    </SpaceBetween>
  );
};

export default StoreDirectApplication;
